<mat-radio-group *ngIf="!multiple"
                 class="options">
  <div *ngFor="let option of options"
       class="option"
       [class.option--blocked]="isOptionBlocked(option) && !isOptionSelected(option)">
    <mat-radio-button [value]="option.optionId.toString()"
                      [checked]="isOptionSelected(option)"
                      [disabled]="isOptionBlocked(option)"
                      (click)="onOptionRadioClick(option, $event)"
                      (change)="onOptionRadioChange(option, $event)"><span class="text">{{option.text}}</span>
    </mat-radio-button>
  </div>
</mat-radio-group>

<section *ngIf="multiple"
         class="options">
  <div class="options-hint" *ngIf="selectionHint">{{selectionHint}}</div>
  <div class="options-warning" *ngIf="validationMessage">{{validationMessage}}</div>
  <div *ngFor="let option of options"
       class="option"
       [class.option--blocked]="isOptionBlocked(option) && !isOptionSelected(option)">
    <mat-checkbox [value]="option.optionId.toString()"
                  [checked]="isOptionSelected(option)"
                  [disabled]="isCheckboxDisabled(option)"
                  (change)="onOptionCheckChange(option, $event)"><span class="text">{{option.text}}</span>
    </mat-checkbox>
  </div>
</section>

